import React, { createContext, useState, useCallback } from 'react';
import LoaderModal from '../components/Modal/LoaderModal';

export const LoaderContext = createContext();

export function LoaderProvider({ children }) {
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');

  const showLoader = useCallback((loaderMessage = '') => {
    setMessage(loaderMessage);
    setIsLoading(true);
  }, []);

  const hideLoader = useCallback(() => {
    setIsLoading(false);
    setMessage('');
  }, []);

  return (
    <LoaderContext.Provider value={{ showLoader, hideLoader, isLoading }}>
      {children}
      <LoaderModal open={isLoading} message={message} />
    </LoaderContext.Provider>
  );
}

export default LoaderProvider;
